// extracted by mini-css-extract-plugin
export default {"separator":"separator--gMIbS","label":"label--WAYTH"};